import styled from 'styled-components';

export const StyledReleases = styled.div`
  & .MuiTableCell-head {
    & .th-summary {
      font-size: 1.4rem;
    }
  }
`;
